exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contact {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@media screen and  (max-width: 767px) {\n    .contact {\n        flex-direction: column;\n    }\n}\n\n@media screen and (min-width: 768px) {\n    .contact {\n        flex-direction: row;\n    }\n}\n\n@media screen and (min-width: 1024px) {\n}\n\n@media screen and (min-width: 1440px) {\n}\n  ", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/views/Root/Footer/responsive.css
// module id = ./node_modules/css-loader/index.js!./src/views/Root/Footer/responsive.css
// module chunks = 0